import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import {AuthGuardData, createAuthGuard} from 'keycloak-angular';
import Keycloak from "keycloak-js";

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated, grantedRoles } = authData;

    const requiredRoles = route.data['roles'];
    // if (!requiredRoles) {
    //     return false;
    // }

    const allUserRoles = [
        ...grantedRoles.realmRoles,
        ...Object.values(grantedRoles.resourceRoles).flat()
    ];

    const hasRequiredRole = requiredRoles?requiredRoles.some((role) =>
        allUserRoles.includes(role)
    ):true;


    const isPharmacyOnlyUser = allUserRoles.includes('PHARMACIE') && !allUserRoles.includes('ADMIN');
    const pharmacyAllowedPrefixes = ['/patients', '/patient-dashboard', '/pharmacie', '/billing'];
    const isPharmacyAllowedRoute = pharmacyAllowedPrefixes.some((prefix) => state.url.startsWith(prefix));

    if (authenticated && hasRequiredRole && (!isPharmacyOnlyUser || isPharmacyAllowedRoute)) {
        return true;
    }
    else if (!authenticated) {
        const keycloak = inject(Keycloak);
        keycloak.login();
    }

    const router = inject(Router);
    return router.parseUrl('/error/403');
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
